module.exports = __webpack_public_path__ + "static/locomotiva-171bf9e3f90fb66697d520ec13103413.png";